import React from "react";
import { Player } from '@lottiefiles/react-lottie-player';
import { useTranslations } from '../../locales/useTranslations';

const KiFaq = () => {
  const { t } = useTranslations();
  return (
    <>
      <div className="faq-area ptb-70 bg-color-f4f5fe">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-12">
              <div className="faq-accordion">
                <h2>
                  <span>{t('ki_faq_title')}</span>
                </h2>

                <div className="native-accordion">
                  <details open>
                    <summary>
                      {t('ki_faq_question1')}
                    </summary>
                    <div className="accordion-content">
                      <p>
                        {t('ki_faq_answer1')}
                      </p>
                    </div>
                  </details>

                  <details>
                    <summary>
                      {t('ki_faq_question2')}
                    </summary>
                    <div className="accordion-content">
                      <p>
                        {t('ki_faq_answer2')}
                      </p>
                    </div>
                  </details>

                  <details>
                    <summary>
                      {t('ki_faq_question3')}
                    </summary>
                    <div className="accordion-content">
                      <p>
                        {t('ki_faq_answer3')}
                      </p>
                    </div>
                  </details>

                  <details>
                    <summary>
                      {t('ki_faq_question4')}
                    </summary>
                    <div className="accordion-content">
                      <p dangerouslySetInnerHTML={{ __html: t('ki_faq_answer4') }} />
                      <ul>
                        <li>{t('ki_faq_answer4_1')}</li>
                        <li>{t('ki_faq_answer4_2')}</li>
                        <li>{t('ki_faq_answer4_3')}</li>
                        <li>{t('ki_faq_answer4_4')}</li>
                        <li>{t('ki_faq_answer4_5')}</li>
                      </ul>
                    </div>
                  </details>

                  <details>
                    <summary>
                      {t('ki_faq_question5')}
                    </summary>
                    <div className="accordion-content">
                      <ul>
                        <li>{t('ki_faq_answer5_1')}</li>
                        <li>{t('ki_faq_answer5_2')}</li>
                        <li>{t('ki_faq_answer5_3')}</li>
                      </ul>
                      <p>{t('ki_faq_answer5_4')}</p>
                    </div>
                  </details>
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-md-12">
              <div className="faq-image">
                <Player
                  autoplay
                  loop
                  src="/images/lottie/faq.json"
                  style={{ height: '300px' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KiFaq;
